import LBox from "@components/LBox";
import LIcon from "@components/LIcon";
import LLink from "@components/LLink";
import LText from "@components/LText";
import UserAvatar from "@components/UserAvatar";
import { useMe } from "@hooks/trpc/useMe";
import * as React from "react";

const ProfileCard = () => {
  const {
    query: { data: user },
  } = useMe();

  if (!user) {
    return null;
  }

  const profileImageUrl = String(user?.image ?? "");
  const blurhash = user?.blurhash;

  return (
    <LLink
      href={{
        pathname: `/(app)/(tabs)/profile/edit`,
      }}
      sentryEventName="profile_card"
    >
      <LBox
        flexDirection="row"
        backgroundColor="favouriteTileBg"
        px="s3"
        py="m1"
        borderRadius="m"
        justifyContent="space-between"
        alignItems={"center"}
      >
        <LBox flexDirection="row" gap="s2" alignItems="center">
          <UserAvatar
            image={profileImageUrl}
            defaultAvatarColors={user?.defaultAvatarColors}
            size={56}
            borderRadius="l"
            blurhash={blurhash}
          />
          <LBox gap="s2">
            <LText fontWeight="800" fontSize={14} variant="bodyM2">
              {user.name}
            </LText>
            <LText variant="bodyM">{user.email}</LText>
          </LBox>
        </LBox>
        <LIcon colors={{ color: "#E6725A" }} name="edit" size={28} />
      </LBox>
    </LLink>
  );
};

export default ProfileCard;
